import { BASE_URL } from 'api';
import { createServer } from 'miragejs';
//import machinesMockData from './machines';
//import stopsMockData from './stops';
//import sensorReadingMockData from './sensorReading';
//import shiftsMockData from './shifts';
//import stopsClassificationMockData from './stopsClasification';
import stopAlertsMockData from './stop-alerts';
import { Logger } from '_clean-code/utils/logger';

const passThroughUrls = [
  `${window.location.origin}/version.json`,
  `${BASE_URL}/**`,
  `${BASE_URL}/version.json`,
  'https://cognito-idp.us-west-2.amazonaws.com',
  'https://cognito-idp.us-west-2.amazonaws.com/**'
];

export function initiateMirage() {
  createServer({
    routes() {
      Logger.info('*** Using mock data for specific urls ***');
      /*
      this.get(
        `${BASE_URL}/v2/stopsClasification/declared-stops/X`,
        () => stopsClassificationMockData.getDeclaredStopsReportMockData.regularCase,
        {
          timing: 1000,
        }
      );

      this.get(
        `${BASE_URL}/v2/sensorReadings/get-machines-working-report/*`,
        () => sensorReadingMockData.getMachinesWorkingReport.regularCase,
        {
          timing: 1000,
        }
      );

      this.get(
        `${BASE_URL}/v2/stopsClasification/get-general-causes-report/*`,
        () => stopsClassificationMockData.getGeneralCausesReportMockData.regularCase,
        {
          timing: 1000,
        }
      );

      this.get(`${BASE_URL}/shifts`, () => shiftsMockData.getByMachine, {
        timing: 1000,
      });

      this.get(`${BASE_URL}/machines/status`, () => machinesMockData.getStatus, {
        timing: 1000,
      });

      */

      /*
      this.get(`${BASE_URL}/v2/stopsByShift`, () => stopsMockData.getByShift, {
        timing: 6000,
      });
      */

      this.get(`${BASE_URL}/v2/stop-alerts`, () => stopAlertsMockData.lastest, {
        timing: 6000
      });

      this.patch(`${BASE_URL}/v2/stop-alerts/:id`, () => true, {
        timing: 6000
      });

      passThroughUrls.forEach((x) => this.passthrough(x));
    }
  });
}
